/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Document
 */
export interface Document {
  /**
   *
   * @type {string}
   * @memberof Document
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Document
   */
  slug: string
  /**
   *
   * @type {string}
   * @memberof Document
   */
  file: string
}

/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  if (!('file' in value) || value['file'] === undefined) return false
  return true
}

export function DocumentFromJSON(json: any): Document {
  return DocumentFromJSONTyped(json, false)
}

export function DocumentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Document {
  if (json == null) {
    return json
  }
  return {
    name: json['name'],
    slug: json['slug'],
    file: json['file'],
  }
}

export function DocumentToJSON(value?: Document | null): any {
  if (value == null) {
    return value
  }
  return {
    name: value['name'],
    slug: value['slug'],
    file: value['file'],
  }
}
